import { OSKIconDefinition } from '../osk-icon.types';

export const oskIconArrowRight: OSKIconDefinition = {
  name: 'arrow-right',
  content: '<path d="M5 12h14" /><path d="m12 5 7 7-7 7" />'
};
